import api from 'api/apiClient';
import { PRIORITY_KEYMAP } from 'modules/shared/constants';
import { formatAmount, formatDate, strToNumber } from 'modules/shared/utils';
import { PROJECT_VIEW_MAP } from 'modules/work-implementation/constants';
import { deriveTaskConfig } from '../analyst/utils';

const unwrap = async (promise) => {
  const res = await promise;
  return res.data;
};

export async function getProjectDetails(id) {
  if (!id) throw new Error('Project ID is required');

  const { data: raw } = await unwrap(await api.get(`/api/analyst/job/${id}`));

  const jobValue = formatAmount(raw.gross_total);
  const jobDate = formatDate(raw.job_date);
  const jobStatus = PROJECT_VIEW_MAP[raw.job_status] || raw.job_status;
  const workCategory = raw.job_work_type;
  const workAge = raw.job_type;
  const columnDrawings = strToNumber(raw.column_drawings_count);
  const structuralDrawings = strToNumber(raw.structural_drawings_count);
  const basementDrawings = strToNumber(raw.basement_drawing_count);
  const groundLevelDrawings = strToNumber(raw.ground_floor_drawing_count);
  const upperFloorDrawings = strToNumber(raw.upper_floor_drawing_count);
  const existingFloorDrawings = strToNumber(raw.existing_floor_count);
  const taskConfig = deriveTaskConfig({
    workCategory,
    workAge,
    columnDrawings,
    structuralDrawings,
    basementDrawings,
    groundLevelDrawings,
    upperFloorDrawings,
    existingFloorDrawings,
  });

  return {
    id: raw.id,
    commonDetails: {
      id: raw.id,
      name: raw.job_name,
      date: jobDate,
      code: raw.job_code,
      status: jobStatus,
      owner: raw.owner?.name,
      value: jobValue,
      totalMilestones: raw.milestone_count,
      completedMilestones: raw.milestones_completed,
    },
    milestones: (raw.milestones || []).map((milestone) => ({
      number: strToNumber(milestone.milestone_number),
      percentage: milestone.payment_percent,
      milestone: milestone.milestone,
      status: milestone.milestone_status,
      amount: (raw.gross_total * milestone.payment_percent) / 100,
    })),
    taskConfig,
  };
}

export async function updateMilestoneStatus(id, data) {
  if (!id) throw new Error('Project ID is required');
  if (!data) throw new Error('Update data is required');

  const payload = {
    job_id: id,
    milestone_number: data.number,
    status: data.status,
  };

  await unwrap(await api.post(`/api/analyst/job/${id}/milestone-achieved`, payload));
}
export async function getTaskList(id) {
  if (!id) throw new Error('Project ID is required');
  const { data: raw } = await unwrap(await api.get(`/api/analyst/job/${id}/tasks`));

  return {
    id: raw.job_id,
    tasks: raw.tasks.map((task) => {
      return {
        id: task.id,
        name: task.task_name,
        status: task.status,
        assignedWeek: task.assigned_week,
        employee: {
          id: task.assigned_to.employee_id,
          name: task.assigned_to.employee_name,
        },
        allottedTime: task.allotted_time,
        priority: PRIORITY_KEYMAP[task.priority],
        note: task.note,
        timeUsed: task.time_used,
        documentsShared: task.documents_shared,
        submissions: task.submissions,
      };
    }),
  };
}
